import { Fragment } from 'react';
import type { OnwheelPricing } from '@/api/cms/onwheel-pricing/types';
import type { DefaultCmsDataResponse } from '@/api/cms/types';
import Button from '@/components/Button';
import CheckIcon from '@/components/icons/CheckIcon';
import MinusIcon from '@/components/icons/MinusIcon';

import { onwheelPricingMappingHeadingData } from '../cooperateData';

type Props = {
  // Declare OnWheelPage props
  onwheelPricingData: DefaultCmsDataResponse<OnwheelPricing>;
};

export default function OnWheelPricing({ onwheelPricingData }: Props) {
  return (
    <section className="bg-primary-10 desktop:py-16 relative overflow-hidden py-12">
      <div className="max-w-8xl desktop:px-8 mx-auto flex flex-col items-center justify-center">
        <article className="desktop:space-y-4 mb-14 flex-col space-y-3 px-4">
          <h2 className="text-title32 text-neutral-90 desktop:text-title42 text-center font-bold">
            Giá cả đơn giản và minh bạch
          </h2>
          <p className="text-body16 text-neutral-90 desktop:text-subtitle18 desktop:font-medium text-center font-normal">
            Chi phí tối ưu cho nhu cầu của khách hàng
          </p>
        </article>
        <div className="desktop:p-6 desktop:rounded-md desktop:shadow-shadow1 px-auto z-[1] mx-auto max-w-6xl bg-white">
          <div className="desktop:hidden">
            {onwheelPricingData
              ? onwheelPricingData.attributes.items.map((item, idx) => (
                  <Fragment key={item.id}>
                    {idx > 0 && (
                      <div className="w-[calc(100% + 2rem)] bg-yellow-10 -mx-4 h-8 "></div>
                    )}
                    <section className="pt-6 pb-8">
                      <div className="mt-8 mb-6 px-4">
                        <h3 className="text-secondary-90 text-title24 mb-4 text-left font-bold">
                          {item.title}
                        </h3>
                        <p className="mb-8 text-sm text-neutral-50">
                          {item.description}
                        </p>
                        <p className="mt-4 mb-8 break-words">
                          <span className="text-subtitle18 font-bold">VND</span>
                          <strong className="text-title32 mx-2 whitespace-nowrap">
                            {item.price_per_month}
                          </strong>
                          <span className="whitespace-nowrap text-neutral-50">
                            /&nbsp;mỗi tháng
                          </span>
                        </p>
                        <Button
                          type="link"
                          href={item.link}
                          fullWidth={true}
                          className="h-9"
                        >
                          {' '}
                          Đăng ký
                        </Button>
                      </div>

                      <table key={item.id} className="w-full">
                        <tbody className="divide-neutral-20 divide-y">
                          {Object.keys(onwheelPricingMappingHeadingData)
                            .length > 0
                            ? Object.keys(onwheelPricingMappingHeadingData).map(
                                (key) => (
                                  <tr
                                    key={key}
                                    className="border-neutral-20 border-t"
                                  >
                                    <th
                                      className="py-5 px-4 text-left text-sm font-normal text-neutral-50"
                                      scope="row"
                                    >
                                      {onwheelPricingMappingHeadingData[key]}
                                    </th>
                                    <td key={item.id} className="py-5 pr-4">
                                      {item.benefits[key] ? (
                                        item.benefits[key] === 'checked' ? (
                                          <CheckIcon
                                            width={20}
                                            height={20}
                                            color="#FE5F00"
                                          />
                                        ) : item.benefits[key] !== '' ? (
                                          onwheelPricingData.attributes.items[0]
                                            .benefits[key]
                                        ) : (
                                          <MinusIcon
                                            width={20}
                                            height={20}
                                            color="#C1C7CD"
                                          />
                                        )
                                      ) : (
                                        <MinusIcon
                                          width={20}
                                          height={20}
                                          color="#C1C7CD"
                                        />
                                      )}
                                    </td>
                                  </tr>
                                )
                              )
                            : null}
                        </tbody>
                      </table>
                      <div className="w-full px-4">
                        <Button
                          type="link"
                          href={item.link}
                          fullWidth={true}
                          className="h-9"
                        >
                          {' '}
                          Đăng ký
                        </Button>
                      </div>
                    </section>
                  </Fragment>
                ))
              : null}
          </div>
          <div className="desktop:block hidden">
            <table className="h-px w-full table-auto">
              <tbody className="divide-neutral-20 divide-y">
                <tr>
                  <th
                    className="text-neutral-90 text-body14 py-8 px-6 text-left align-top font-medium"
                    scope="row"
                  >
                    {' '}
                  </th>
                  {onwheelPricingData.attributes?.items
                    ? onwheelPricingData.attributes.items.map((item) => (
                        <td
                          key={item.id}
                          className="h-full py-8 px-6 align-top"
                        >
                          <h3 className="text-secondary-90 text-title24 mb-4 text-left font-bold">
                            {item.title}
                          </h3>
                          <p className="text-body14 mb-8 text-neutral-50">
                            {item.description}
                          </p>
                          <p className="mt-4 mb-8 break-words">
                            <span className="text-subtitle18 font-bold">
                              VND
                            </span>
                            <strong className="text-title32 mx-2 whitespace-nowrap">
                              {item.price_per_month}+
                            </strong>
                            <span className="whitespace-nowrap text-neutral-50">
                              /&nbsp;mỗi tháng
                            </span>
                          </p>
                          <Button
                            type="link"
                            href={item.link}
                            fullWidth={true}
                            className="h-9"
                          >
                            {' '}
                            Đăng ký
                          </Button>
                        </td>
                      ))
                    : null}
                </tr>

                {Object.keys(onwheelPricingMappingHeadingData).length > 0
                  ? Object.keys(onwheelPricingMappingHeadingData).map((key) => (
                      <tr key={key}>
                        <th
                          className="text-body14 py-5 px-6 text-left font-normal text-neutral-50"
                          scope="row"
                        >
                          {onwheelPricingMappingHeadingData[key]}
                        </th>
                        {onwheelPricingData.attributes.items.map((p) => (
                          <td key={p.id} className="py-5 px-6">
                            {p.benefits[key] ? (
                              p.benefits[key] === 'checked' ? (
                                <CheckIcon
                                  width={20}
                                  height={20}
                                  color="#FE5F00"
                                />
                              ) : p.benefits[key] !== '' ? (
                                p.benefits[key]
                              ) : (
                                <MinusIcon
                                  width={20}
                                  height={20}
                                  color="#C1C7CD"
                                />
                              )
                            ) : (
                              <MinusIcon
                                width={20}
                                height={20}
                                color="#C1C7CD"
                              />
                            )}
                          </td>
                        ))}
                      </tr>
                    ))
                  : null}
              </tbody>
              <tfoot>
                <tr className="border-neutral-20 border-t">
                  <th className="sr-only" scope="row">
                    Choose your plan
                  </th>
                  {onwheelPricingData.attributes?.items.map((item) => (
                    <td key={item.id} className="px-6 pt-8">
                      <Button
                        type="link"
                        href={item.link}
                        fullWidth={true}
                        className="h-9"
                      >
                        {' '}
                        Đăng ký
                      </Button>
                    </td>
                  ))}
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="bg-primary-40 desktop:-right-40 desktop:h-[442px] desktop:w-[442px] absolute top-0 -right-28 h-[221px] w-[221px] rounded-bl-full opacity-10"></div>
    </section>
  );
}
